import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import CurrencyInput from "@my-dld/components/Form/CurrencyInput";
import { RTRegistrationProps, TrackIndex } from "./RTRegistration";

const DLDPaymentTypes = [
	{
		name: LVStrings.online_payment_e_pay,
		code: "online",
	},
	{
		name: LVStrings.offline_payment,
		code: "offline",
	},
];

interface State {
	worthNeed: boolean;
	rentNeed: boolean;
	paymentType: string;
	worth: string;
	rent: string;
	error: { [ k: string ]: string };
}

class ProcedureDetails extends Component<RTRegistrationProps, State> {
	constructor( props: RTRegistrationProps ) {
		super( props );
		this.state = {
			worthNeed: props.procedure.WorthValueNeeded,
			rentNeed: props.procedure.RentValueNeeded,
			...stateFromProps( props ),
			error: {},
		} as State;
	}

	render() {
		const { worthNeed, rentNeed, paymentType, error } = this.state;
		return <div className="procedure-details" id="procedure_Details">
			<div className="card">
				<div className="card-header">
					<span>{ Strings.rt_procedure_details }</span>
				</div>
				<div className="card-body">
					<div className="mb-3">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					<div className="row">
						{ ( worthNeed || rentNeed ) &&
							<div className="col-md-12 online-reg-section-title">{ this.getTitle() }</div> }
						{ worthNeed && <div className="col-md-6 form-group">
							<CurrencyInput
								id={ "worth" }
								holder={ this }
								required={ true }
								label={ Strings.procedure_value }
								currencyType={ Strings.aed }
								error={ error.worth }
								containerClassName={ "input-group input-group-custom" }/>
						</div> }
						{ rentNeed && <div className="col-md-6 form-group">
							<CurrencyInput
								id={ "rent" }
								holder={ this }
								required={ true }
								label={ Strings.rent_value }
								currencyType={ Strings.aed }
								error={ error.rent }
								containerClassName={ "input-group input-group-custom" }/>
						</div> }
						<div className="col-md-12">
							<hr/>
						</div>
                        <div className="col-md-12 online-reg-section-title mt-2">{Strings.rt_dld_fees}<span className="asterisk">*</span></div>
						<div className="col-md-12 dld-pay-type-selection">
							{ DLDPaymentTypes.map( ( type ) => {
								return <RenderCheck
									key={ "DLDFee_" + type.code }
									type={ type }
									isChecked={ type.code === paymentType }
									onPress={ ( code ) => this.setState( { paymentType: code } ) }/>;
							} ) }
						</div>
					</div>
				</div>
			</div>
			<div className="form-group">
				<button
					className="btn btn_1 btn_style1"
					onClick={ this.onProceed }>{ Strings.rt_proceed_parties_information }</button>
				<button type="button" className="btn btn-link" onClick={ this.onReset }>{ Strings.reset }</button>
			</div>
		</div>;
	}

	private getTitle() {
		const { worthNeed, rentNeed } = this.state;
		if ( worthNeed && rentNeed ) {
			return Strings.rt_specify_procedure_and_rent_value;
		} else if ( worthNeed ) {
			return Strings.rt_specify_procedure_value;
		} else if ( rentNeed ) {
			return Strings.rt_specify_rent_value;
		}
	}

	private onProceed = () => {
		if ( this.isValid() ) {
			const state = this.state;
			const procedure = this.props.holder.state.procedure;
			procedure.WorthValue = parseFloat( state.worth );
			procedure.RentValue = parseFloat( state.rent );
			procedure.DLDOnlineFees = ( state.paymentType === "online" );
			this.props.onNext( TrackIndex.PROCEDURE_DETAILS );
		}
	};

	private onReset = () => {
		this.setState( {
			worth: "",
			rent: "",
		} );
	};

	private isValid() {
		let isValid = true;
		const { worth, rent, worthNeed, rentNeed } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( worthNeed && ( StringUtil.isEmptyStringOrNull( worth ) || parseFloat( worth ) === 0 ) ) {
			isValid = false;
			error.worth = Strings.required;
		}
		if ( rentNeed && ( StringUtil.isEmptyStringOrNull( rent ) || parseFloat( rent ) === 0 ) ) {
			isValid = false;
			error.rent = Strings.required;
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	}
}

function stateFromProps( props: RTRegistrationProps ) {
	const procedure = props.procedure;
	const worth = procedure.WorthValue;
	const rent = procedure.RentValue;
	const result: Partial<State> = {
		worth: ( worth && worth !== 0 ) ? "" + worth : "",
		rent: ( rent && rent !== 0 ) ? "" + rent : "",
		paymentType: procedure.DLDOnlineFees ? "online" : "offline",
	};
	return result;
}

function RenderCheck( props: { type: any, isChecked: boolean, onPress: ( code: string ) => void } ) {
	const { type, isChecked, onPress } = props;
	const id = "DLDFee_" + type.code;
	return <div
		className="custom-control custom-radio"
		onClick={ () => onPress( type.code ) }>
		<input
			type="radio" id={ id } name="customRadio"
			className="custom-control-input" checked={ isChecked } onChange={ () => onPress( type.code ) }/>
		<label className="custom-control-label" htmlFor={ id }>{ LocaleUtil.getLocalValue( type.name ) }</label>
	</div>;
}

export default ProcedureDetails;
